<template>
    <div class="body">
            <p  class="font1" style="padding-top: 13vh;">轻拾芳菲，回望流年</p>
            <p  class="font1" style="padding-top: 1vh;">努力走的每一步，都算数</p>

            <p class="font2" style="padding-top: 2vh;">2023年你在富学宝典上的学习成就</p>

            <div class="list" style="margin-top: 2vh;">
                <!-- <i class="fa fa-clock-o fa-2x"></i> -->
                <p class="font2">累计学习<a class="font3">{{ ReportData.playtime }}</a>小时</p>
            </div>
            <div class="list">
                <!-- <i class="fa fa-book fa-2x"></i> -->
                <p class="font2">学习课程<a class="font3">{{ ReportData.coursenumMon }}</a>门</p>
            </div>
            <div class="list">
                <!-- <i class="fa fa-trophy fa-2x"></i> -->
                <p class="font2">获得学分<a class="font3">{{ ReportData.creditValueFxbd }}</a>个</p>
            </div>

            <p class="font2" style="padding-top: 2vh;">超越了<a class="font3">{{ ReportData.rate1 }}%</a>同行小伙伴！</p>
    </div>
</template>


<script>
import AddNumber from './AddNumber.vue';
export default {
      props: ["ReportData"],
      components:{AddNumber},
      data() {
        return {
        }
      },
    }
</script>
  
<style scoped>
.body {
    background:url("../../assets/year23/bg2.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
}
.list{
    /* display: flex;
    align-items: center;
    width: 70%;
    margin:0 auto;
    padding: 0; */
    display: flex;
    justify-content: center; 
    align-items: center; 
    width: 70%;
    height: 7vh;
    margin: 0 auto;
    background-color: #957dcb;
    margin-top: 1vh;
    border-radius: 10px;
    border: #fff solid 1px;
}
.font1 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 20px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 30px;
    font-weight: bold;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.fa{
    color:rgb(206, 144, 28);
    align-items: center;
}
.AddNumber-com {
    font-size: 30px;
    font-weight: bold;
    color: orange;
}
</style>